<template>
  <div :key="refreshpage" class="container-fluid m-0 staticPage">
    <loading v-if="!enable">
      <template v-slot:Detail>درصورت لود نشدن صفحه را رفرش نمایید</template>
    </loading>
    <div class="row bg-dark">
      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <a class="navbar-brand Pointer" style="font-size: 15px !important" @click="GotoLogin">سامــــــانه اینترنت بانک </a> <span class="text-warning mr-3" style="font-size: 15px !important"> {{ $store.state.NameSandogh }} </span>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse text-right" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <!-- <li class="nav-item active">
              <a class="nav-link mx-2" href="#" style="font-size: 15px !important">اخبار <span class="sr-only">(current)</span></a>
            </li> -->
            <!-- <li class="nav-item mx-3">
              <a class="nav-link Pointer" target="_blank" style="font-size: 15px !important">ارتباط با ما</a>
            </li> -->
            <li class="nav-item mx-3">
              <a :href="$router.resolve('AboutUs').href" class="nav-link Pointer" tag="a" style="font-size: 15px !important">درباره ما</a>
            </li>
            <!-- <li class="nav-item dropdown text-right">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> شعب </a>
              <div class="dropdown-menu text-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">شعبه اول</a>
                <a class="dropdown-item" href="#"> شعبه دوم</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">شعبه سوم</a>
              </div>
            </li> -->
            <!-- <li class="nav-item">
              <a class="nav-link disabled" href="#">Disabled</a>
            </li> -->
          </ul>
        </div>
      </nav>
    </div>
    <!-- اسلایدر -->
    <div class="row">
      <div class="col-12">
        <div class="mt-2 w-100">
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
              <!-- <li data-target="#carouselExampleIndicators" data-slide-to="1"></li> -->
              <!-- <li data-target="#carouselExampleIndicators" data-slide-to="2"></li> -->
            </ol>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img class="d-block w-100" src="../../../public/img/Img1.jpg" alt="First slide" />
              </div>
              <!-- <div class="carousel-item">
                <img class="d-block w-100" src="../../../public/img/Yalda1401-2.jpg" alt="Second slide" />
              </div> -->
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- باکس ها -->
    <div :key="enable" class="row mt-2 pt-0">
      <div class="col-md-3 col-12 p-3">
        <div class="access-btn pt-5 pb-5 rounded p-2 text-center" :class="enable ? ' Hover-Efect bg-1' : 'bg-secondary'">
          <a :href="enable ? $router.resolve('DepositWhithoutLogin').href : '#'">
            <h2 class="text-light"><span class="fas fa-credit-card"></span></h2>
          </a>
          <h3>واریز به حساب | پرداخت اقساط</h3>
        </div>
      </div>
      <div class="col-md-3 col-12 p-3">
        <div class="access-btn pt-5 pb-5 rounded p-2 text-center" :class="enable ? ' Hover-Efect bg-2' : 'bg-secondary'">
          <a :href="enable ? $router.resolve('Register').href : '#'">
            <h2 class="text-light"><span class="fas fa-user-plus"></span></h2>

            <h3>درخواست عضویت در صندوق</h3>
          </a>
        </div>
      </div>
      <div class="col-md-3 col-12 p-3">
        <div @click="GotoLogin" class="access-btn pt-5 pb-5 rounded Pointer p-2 text-center" :class="enable ? ' Hover-Efect bg-3' : 'bg-secondary'">
          <span>
            <h2 class="text-light text-secondary">
              <span class="fas fa-key"></span>
            </h2>
            <h3>ورود به سامانه اینترنت بانک</h3>
          </span>
        </div>
      </div>
      <div class="col-md-3 col-12 p-3">
        <div class="access-btn pt-5 pb-5 rounded p-2 text-center" :class="enable ? ' Hover-Efect bg-4' : 'bg-secondary'">
          <a :href="enable ? $router.resolve('Rememberpassword').href : '#'">
            <h2 class="text-light">
              <span class="fas fa-lock-open"></span>
            </h2>
            <h3>فراموشی رمز عبور</h3>
          </a>
        </div>
      </div>
    </div>
    <!-- اخبار -->
    <div class="text-center mt-3 mb-5">
      <span class="ml-5"> _____________ </span>
      <span class="font-weight-bold" style="font-size: 30px !important"> خبـــرها </span>
      <span class="mr-5"> _____________ </span>
    </div>
    <!-- فوتر -->
    <div class="footer py-3">
      طراحی و پیاده سازی توسط
      <a target="_blank" class="text-warning" href="https://bnpco.ir">شرکت پاسارگاد</a>
    </div>
  </div>
</template>
<script>
import Loading from '../Tools/NetPa/Loading.vue'
export default {
  components: { Loading },
  data() {
    return {
      DataAxiosWcf: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Wcf',
      },
      enable: false,
      refreshpage: 0,
    }
  },
  methods: {
    GatImg() {
      // return './Image/U1-6.png'
      return 'background-image:url("./Image/back.jpg");background-size: cover; height: 100vh;'
    },
    GotoLogin() {
      this.$session.set('ForceLoginpage', true)
      this.$router.push({
        name: 'LoginPage',
      })
    },
    gettblCustomer() {
      this.$PostData({
        ArryfildValue: {},
        Action: 'GetTblCustomer',
        method: 'GET',
        Token: '',
      }).then((data) => {
        this.$store.state.NameSandogh = data.name
        this.$session.set('NameSandogh', data.name)
        this.$session.set('CustCode', data.custCode)
        document.title = data.name
        this.enable = true
        this.refreshpage++
      })
    },
  },
  created() {
    this.gettblCustomer()
  },
  mounted() {
    var ver = localStorage.getItem('VersionSoftware')
    if (ver == null) {
      localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
    } else {
      var OldVer = localStorage.getItem('VersionSoftware')
      var NewVer = this.$store.state.VersionSoftware
      if (OldVer != NewVer) {
        localStorage.setItem('VersionSoftware', this.$store.state.VersionSoftware)
        this.$swal({
          title: 'بروزرسانی جدید',
          text: 'نسخه جدید در دسترس میباشد ، لطفا تایید نمایید تا نسخه شما بروزرسانی شود',
          icon: 'success',
          position: 'center',
          confirmButtonText: 'تایید',
          showConfirmButton: true,
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload(true)
          }
        })
      }
    }
  },
}
</script>
<style scoped>
.footer {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: #202020;
  color: white;
  text-align: center;
}
.staticPage {
  padding: 2%;
  min-height: 100vh !important;
  background: #fff !important;
}
h2 span {
  font-size: 70px !important;
}
h3 {
  color: white;
  font-size: 20px !important;
  margin-top: 35px;
  margin-top: 35px;
}
.bg-1 {
  background: #7e549e;
}
.bg-2 {
  background: #c2549d;
}
.bg-3 {
  background: #fc8370;
}
.bg-4 {
  background: #d4b117;
}
.Hover-Efect:hover span.fas {
  transform: rotate(30deg);
  transition: 0.5s;
  font-size: 80px !important;
  /* color: #e6063e; */
}
.Hover-Efect span.fas {
  transition: 1s;
}
</style>
<style></style>
